<template>
    <div id="suggestions" style="position: relative;">
        <div class="suggestion-labels" ref="suggestionLabels">
            <!-- Suggestions will be added dynamically here -->
        </div>
    </div>
</template>

<script>
    const MAX_SUGGESTIONS = 1000
    import $ from 'jquery';
    export default {
        name: 'AddressSuggestions',
        props: {
            onSelected: {
                type: Function,
                default() { return function(){} }
            }
        },
        methods: {
            _showSuggestionsNoLoad(suggestionList) {
                var vm = this
                const suggestions = this.$refs.suggestionLabels;
                suggestions.innerHTML = '';

                var resultedSuggestions = 0;
                suggestionList.forEach((suggestion) => {
                    const label = document.createElement('label');
                    label.innerHTML = ""
                    label.innerHTML += "<label class='suggestion_label_carr'>" + suggestion + "</label>"
                    label.addEventListener('click', () => {
                      vm.onSelected(suggestion)
                    });
                    suggestions.appendChild(label);
                    resultedSuggestions += 1;
                });

                if (resultedSuggestions > 0) {
                    suggestions.style.display = 'block';
                    //document.getElementById(vm.inputId).focus()
                } else {
                    suggestions.style.display = 'none';
                }
            },

            showSuggestions(inputValue) {
                var vm = this;
                $.ajax({
                    type: "GET",
                    url: global.BACKEND_URL + `/get_organisation_names?start=${inputValue}&from=0&to=${MAX_SUGGESTIONS}`,
                    success: function (data) {
                        let all_options = data
                        vm._showSuggestionsNoLoad(all_options);
                    },
                    error: function () { },
                    dataType: "json",
                    contentType: "application/json"
                });
            },
            hideSuggestions() {
                var vm = this;
                setTimeout(function(){
                    const suggestions = vm.$refs.suggestionLabels;
                    suggestions.style.display = 'none';
                },200);
            }
        }
    }
</script>

<style lang="css" scoped src="@/assets/css/organisation_suggestions.css"></style>

